<template>
    <div>
        <inserir-atualizar-item-despesa-form
            :mostrarModal="mostrarModal"
            :acao="acao"
            :opcoes="opcoes"
            @fechar="$emit('fechar')"
            @inserirItem="inserirItem($event)"
            @atualizarItem="atualizarItem($event)"
            :itemAtualizar="itemAtualizar"
        ></inserir-atualizar-item-despesa-form>
    </div>
</template>

<script>
import InserirAtualizarItemDespesaForm from '@/app/despesasgerais/componentes/itensDespesas/InserirAtualizarItemDespesaForm';
import ItensDespesasServicos from './ItensDespesasServicos';

export default {
    props: {
        mostrarModal: {
            type: Boolean
        },

        acao: {
            type: String
        },  

        despesa: { 
            type: Object
        },

        itemAtualizarId: {
            type: String,
        },
    },

    components: {
        InserirAtualizarItemDespesaForm
    }, 

    data() {
        return {
            opcoes: {},
            itemAtualizar: null
        }
    },
    
    methods: {
        obterItem() {
            this.$store.dispatch('addRequest')
            ItensDespesasServicos.obterPorId(this.itemAtualizarId).then(response => {
                if (response) {
                    if (response.success) {
                        this.itemAtualizar = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        
        inserirItem(itemDto) {
            itemDto.despesaId = this.despesa.despesaId
            this.$store.dispatch('addRequest')
            ItensDespesasServicos.inserirItemDespesa(itemDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Item inserido com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizar')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                } 
                this.$store.dispatch('removeRequest')
            })
            this.$emit('fechar')
        },

        atualizarItem(itemDto) {
            itemDto.despesaId = this.despesa.despesaId
            this.$store.dispatch('addRequest')
            ItensDespesasServicos.atualizarItemDespesa(itemDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Item atualizado com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizar')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                } 
                this.$store.dispatch('removeRequest')
            })
            this.$emit('fechar')
        },

        obterItemDespesaOpcoes() {
            this.$store.dispatch('addRequest')
            ItensDespesasServicos.obterItemDespesaOpcoes().then(response => {
                if (response) {
                    if (response.success) {
                        this.opcoes = response.data
                    } else {
                        this.$toast.error(
                            'Não foi possivel obter as listagens de dados',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                } 
                this.$store.dispatch('removeRequest')
            })
        }
    },   
    
    watch: {
        mostrarModal() {
            if (this.mostrarModal) {
                this.obterItemDespesaOpcoes()
                if (this.acao == 'ATUALIZAR') {
                    this.obterItem()
                }
            }
        }
    }
}
</script>